import { Component, OnInit } from '@angular/core';
import {FormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {Store} from '@ngrx/store';

import {ProfileService} from '../profile.service';

import * as ProfileActions from './../store/profile.actions';
import * as fromApp from './../../store/app.reducers';
import * as fromProfile from './../store/profile.reducers';
import * as fromUser from './../../user/store/user.reducers';
import {Observable} from 'rxjs';
import {ToastrService} from 'ngx-toastr';

@Component({
    selector: 'app-profile-add',
    templateUrl: './profile-add.component.html',
    styleUrls: ['./profile-add.component.scss'],
    standalone: false
})
export class ProfileAddComponent implements OnInit {

  profileForm: UntypedFormGroup;
  hasLimit: boolean;
  profileState: Observable<fromProfile.State>;

  constructor(
    private store: Store<fromApp.AppState>,
    private profileService: ProfileService,
    private notifierService: ToastrService
  ) { }

  ngOnInit() {
    this.profileState = this.store.select('profile');
    this.profileService.hasActiveLimit().subscribe(
      (hasLimit: boolean) => {
        this.hasLimit = hasLimit;
      }
    );
  }

}
